var base = require('settings/teams/team-members');

Vue.component('spark-team-members', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/teams/team-members.js